import { Grid } from "@mui/material";
import { IProdutoPedido } from "../../../pedidos/interface/IProdutoPedido";
import { ICategoria } from "../../interfaces/ICategoria";
import { IProduto } from "../../interfaces/IProduto";
import { CardProdutoCarrinhoOperacao } from "../../components/CardProdutoCarrinhoOperacao";
import { CardComboCarrinhoOperacao } from "../../components/CardComboCarrinhoOperacao";
import { useOperacaoContext } from "../../../pedidos/contexts/OperacaoContext";
import { TipoPedido } from "../../../pedidos/enum/TipoPedido";
import { useMemo } from "react";

interface ProdutosCarrinhoContainerProps {
    categorias: ICategoria[];
    produtosCarrinho: IProdutoPedido[];
    aumentarQuantidade: (produtoUuid: string) => void;
    diminuirQuantidade: (produtoUuid: string) => void;
    removerProduto: (produtoUuid: string) => void;
    editarProduto: (produto: IProdutoPedido) => void;
}

type GrupoCarrinho =
    | { type: 'single'; produto: IProdutoPedido; produtoOriginal?: IProduto }
    | { type: 'combo'; comboUuid: string; comboDescricao?: string; items: IProdutoPedido[] };

export const ProdutosCarrinhoContainer = ({ categorias, produtosCarrinho, aumentarQuantidade, diminuirQuantidade, editarProduto, removerProduto }: ProdutosCarrinhoContainerProps) => {
    const { selecionarProduto, produtosSelecionados, tipo } = useOperacaoContext();

    const grupos = useMemo<GrupoCarrinho[]>(() => {
        const result: GrupoCarrinho[] = [];
        const seen = new Set<string>();

        for (const produto of produtosCarrinho) {
            if (produto.comboUuid) {
                if (!seen.has(produto.comboUuid)) {
                    seen.add(produto.comboUuid);
                    result.push({
                        type: 'combo',
                        comboUuid: produto.comboUuid,
                        comboDescricao: produto.comboDescricao,
                        items: produtosCarrinho.filter(p => p.comboUuid === produto.comboUuid)
                    });
                }
            } else {
                let produtoOriginal: IProduto | undefined = undefined;
                categorias?.forEach(categoria => {
                    if (!produtoOriginal) {
                        produtoOriginal = categoria.produtos?.find(p => p.uuid === produto.uuidProdutoReferencia);
                    }
                });
                result.push({ type: 'single', produto, produtoOriginal });
            }
        }

        return result;
    }, [produtosCarrinho, categorias]);

    const removerCombo = (comboUuid: string) => {
        produtosCarrinho
            .filter(p => p.comboUuid === comboUuid)
            .forEach(p => removerProduto(p.uuid));
    };

    return (
        <Grid
            container
            spacing={2}
            sx={{
                padding: "1rem",
            }}
        >
            {grupos.map(grupo => {
                if (grupo.type === 'combo') {
                    return (
                        <Grid item xs={12} md={8} lg={(12 / 5) * 2} key={grupo.comboUuid}>
                            <CardComboCarrinhoOperacao
                                comboDescricao={grupo.comboDescricao}
                                items={grupo.items}
                                removerCombo={() => removerCombo(grupo.comboUuid)}
                            />
                        </Grid>
                    );
                }

                return (
                    <Grid item xs={12} md={4} lg={(12 / 5)} key={grupo.produto.uuid}>
                        <CardProdutoCarrinhoOperacao
                            produto={grupo.produto}
                            aumentarQuantidade={aumentarQuantidade}
                            diminuirQuantidade={diminuirQuantidade}
                            removerProduto={removerProduto}
                            editarProduto={editarProduto}
                            produtoOriginal={grupo.produtoOriginal}
                            selecionar={tipo == TipoPedido.mesa ? selecionarProduto : undefined}
                            selecionado={produtosSelecionados.find(ps => ps.uuid == grupo.produto.uuid) ? true : false}
                        />
                    </Grid>
                );
            })}
        </Grid>
    );
}
